import { render, staticRenderFns } from "./AssessmentChip.vue?vue&type=template&id=0ab9cfa5&scoped=true&"
import script from "./AssessmentChip.vue?vue&type=script&lang=ts&"
export * from "./AssessmentChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab9cfa5",
  null
  
)

export default component.exports